import getUrlParameter from './get-url-parameter';
import cookieOptions from './cookie-options';
import Cookie from 'js-cookie';

function customTracker() {
	var tid = getUrlParameter('tid') || null,
		subid = getUrlParameter('subid') || null,
		utm_source = getUrlParameter('utm_source') || null,
		utm_medium = getUrlParameter('utm_medium') || null,
		utm_campaign = getUrlParameter('utm_campaign') || null,
		utm_term = getUrlParameter('utm_term') || null,
		utm_content = getUrlParameter('utm_content') || null;
		
	if (tid || subid || utm_source || utm_medium || utm_campaign || utm_term || utm_content) {
		Cookie.set(
			'UM_REF',
			JSON.stringify({
				tid,
				subid,
				utm_source,
				utm_medium,
				utm_campaign,
				utm_term,
				utm_content
			}),
			cookieOptions
		);
	}
}
	
export default customTracker;